import type { NextPage } from "next";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import DoubleSection from "../components/LandingPage/DoubleSection";
import EarningSection from "../components/LandingPage/EarningSection";
import HeroSection from "../components/LandingPage/HeroSection";
import InfoSection from "../components/LandingPage/InfoSection";
import ReasonSection from "../components/LandingPage/ReasonSection";
import TradingSection from "../components/LandingPage/TradingSection";
import NavBar from "../components/Common/NavBar";
import Footer from "../components/Common/Footer";
import loggedIn from "../HOC/loggedIn";

const Home: NextPage = () => {
  return (
    <div>
      <div className="custom-bg-1">
        <NavBar />
        <HeroSection />
      </div>
      <TradingSection />
      <div className="custom-bg-1">
        <DoubleSection />
      </div>
      <div className="custom-bg-2">
        <InfoSection />
      </div>
      <div className="custom-bg-3 rounded-t-[3rem] sm:rounded-t-[5rem] lg:rounded-t-[12rem]">
        <ReasonSection />
      </div>
      {/* <EarningSection/> */}
      <div className="custom-bg-4">
        <Footer />
      </div>
    </div>
  );
};

export default loggedIn(Home);
